import DetectionUtil from './util/detection';
import InitializationUtil from './util/initialization';
import HelpersUtil from './util/helpers';
import ColorUtil from './util/color';
import KeyboardUtil from './util/keyboard';
import StringUtil from './util/string';
import FocusControls from './util/focus-controls';
import TransitionUtil from './util/transitions';

const Util = {
  ...DetectionUtil,
  ...HelpersUtil,
  ...InitializationUtil,
  ...ColorUtil,
  ...KeyboardUtil,
  ...StringUtil,
  FocusControls,
  ...TransitionUtil
};

export default Util;
